<template>
    <div>
        <!-- import story -->
        <app-story :key="forceReloadStoryKey"></app-story>

        <!-- import home splash -->
        <app-splash></app-splash>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import Story from './homeParts/Story.vue'
import Splash from './homeParts/Splash.vue'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: 'Home',
    data() {
        return {
            forceReloadStoryKey: 0,
        }
    },
    methods: {
        ...mapActions(['fetchStories']),
    },
    computed: {
        ...mapGetters(['setStories', 'headerSearchBar']),
    },
    components: {
        appStory: Story,
        appSplash: Splash,
    },
    watch: {
        setStories() {
            this.forceReloadStoryKey += 1
        },
    },
    created() {
        webpageTitle(`Home`)
        this.$emit('update:layout', LayoutGeneral);
    },
}
</script>